export default __webpack_public_path__ + "static/media/install_android.e2daff30.png";